import { useAppDispatch } from '../grid/reduxStore/Store';
import { setIsLocked } from '../grid/reduxStore/documentSettingsSlice';
import { ErrorCode } from '../../../services/socket/SocketEvents';

export const useCheckDocumentLockStatus = () => {
  const dispatch = useAppDispatch();
  return (errorCode: ErrorCode) => {
    if (errorCode === ErrorCode.LOCKED) {
      dispatch(setIsLocked(true));
      return true;
    }
    return false;
  };
};
